import { defineComponent as _defineComponent } from 'vue'
import {
  FeeDirection,
  FeeReason,
  FeeState,
  PaginatedQuery,
  feeStateLabels,
  feeDirectionLabels,
  applyFeeToLabel,
} from 'ah-api-gateways';
import { feeAdjustmentTableFields } from '../../models/feesTableFields';
import { CustomFeeReason, FeeType, SingleClientOutstandingFee } from 'ah-api-gateways/models/feesAndCharges/fees';
import BankAccountRail from 'ah-beneficiaries/src/components/bankAccounts/BankAccountRail.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { PropType, computed, onBeforeMount, ref, useAttrs, useListeners } from 'vue';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useAhTradesState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import SingleOwnerOutstandingFeesRowDetails from './SingleOwnerOutstandingFeesRowDetails.vue';

interface SingleClientOutstandingFeeEmits extends UseManagedListingEmits<SingleClientOutstandingFee> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleOwnerOutstandingFeesListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: feeAdjustmentTableFields }),
  },
  clientOrPartnerId: {
    type: String,
    required: true,
  },
  userType: {
    type: String as PropType<'client' | 'partner'>,
    required: true,
    default: 'client',
  },
  ...defineUseManagedListingProps<SingleClientOutstandingFee>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const tradeState = useAhTradesState();

const attrs = useAttrs();

const listeners = useListeners();

const requestManager = useRequestManager().manager;

const feeTypesOptions = ref<FeeType[]>([]);

const isAHUser = computed(() => tradeState.store.useAuthStore().isAHUser);



const managedListing = useManagedListing<SingleClientOutstandingFee>({
  loadDataRequest: (query: PaginatedQuery) =>
    tradeState.services.fees.listOwnerOutstandingFees({
      ...query,
      [props.userType === 'client' ? 'clientId' : 'partnerId']: props.clientOrPartnerId,
      ...(props.userType !== 'client' && { excludeClient: true }),
    }),
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: requestManager,
});

function stateLabel(fee: SingleClientOutstandingFee) {
  return feeStateLabels[fee.state as any as FeeState];
}

function feeDirectionDescription(feeDirection: FeeDirection) {
  return feeDirectionLabels[feeDirection];
}

function applyFeeToDescription(feeDirection: FeeDirection) {
  return applyFeeToLabel[feeDirection]!;
}

function feeTypeDescription(feeType: FeeReason) {
  return feeTypesOptions.value?.find((type) => type.value === feeType)?.description;
}

function getFeeTypes() {
  requestManager
    .sameOrCancelAndNew('getFeeTypes', tradeState.services.fees.getFeeTypes())
    .subscribe((getFeeTypesResponse: FeeType[]) => {
      feeTypesOptions.value = getFeeTypesResponse;
    });
}

const customFeeReasonOptions = ref<CustomFeeReason[]>([]);

function getCustomFeeReasons() {
  requestManager
    .sameOrCancelAndNew('getCustomFeeReasons', tradeState.services.fees.getCustomFeeReasons())
    .subscribe((getCustomFeeReasonsResponse: CustomFeeReason[]) => {
      customFeeReasonOptions.value = getCustomFeeReasonsResponse;
    });
}

function getCustomFeeReasonDescription(customFeeReason: string): string {
  const reason = customFeeReasonOptions.value.find((r) => r.value === customFeeReason);
  return reason ? reason.description : '';
}

onBeforeMount(() => {
  getFeeTypes();
  getCustomFeeReasons();
});

expose({ loadData: managedListing.loadData });

return { __sfc: true,props, tradeState, attrs, listeners, requestManager, feeTypesOptions, isAHUser, emit, managedListing, stateLabel, feeDirectionDescription, applyFeeToDescription, feeTypeDescription, getFeeTypes, customFeeReasonOptions, getCustomFeeReasons, getCustomFeeReasonDescription, FeeReason, BankAccountRail, formatCurrencyValue, formatDate, SingleOwnerOutstandingFeesRowDetails }
}

})